// extracted by mini-css-extract-plugin
module.exports = {"root":"PerfectScrollbar_root__O5p4_","mobile":"PerfectScrollbar_mobile__HEvkK"};